/* eslint-disable */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import cssKit from '../../css';

export const NextStepsWrapperStyled = styled.div`
  width: 100%;
  max-width: 1200px; // if ("index-legacy-navs.html") max-width: 1067px;
  margin: 0 auto;
  overflow: hidden;

  ${cssKit.media.greaterThan('medium') `
    padding: 0 15px; // if ("index-legacy-navs.html") padding: 0;
    // width: 100%; // if ("index-legacy-navs.html") width: 83.33%;

    margin-bottom: ${(props) => (props.moreMarginBottom ? '40px' : '0')};
  `};
`;

export const NextStepsContentStyled = styled.div`
  position: relative;
  padding: ${(props) => (props.noBg ? '0' : '15px 0')};
  overflow: hidden;

  ${cssKit.media.greaterThan('medium') `
    padding: ${(props) => (props.noBg ? '0' : '40px 0')};
  `};

  &:before,
  &:after {
    content: '';
    display: ${(props) => (props.noBg ? 'none' : 'block')};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 120px;
    background-color: #f1f1ef;
    z-index: -1;

    ${cssKit.media.greaterThan('medium') `
      height: 170px;
    `};
  }
  &:after {
    top: 120px;
    height: 100%;
    transform-origin: 0 0;
    transform: skewX(70deg);

    ${cssKit.media.greaterThan('medium') `
      top: 170px;
      transform: skewX(80deg);
    `};
  }
`;
export const LeadFormCopyBoxStyled = styled.div`
  background-color: #f1f1ef;
  padding: 15px 0 45px 0;

  ${cssKit.media.greaterThan('medium') `
    padding: 40px 0 65px 0;
  `};
`;
export const DealerListCopyBoxStyled = styled.div`
  background-color: #f1f1ef;
  padding: 15px;
  margin-bottom: 10px;
  ${cssKit.media.greaterThan('medium') `
    padding: 40px 0 30px;
  `};
`;

export const nextStepsHeaderMixin = (props) => {
  return css`
    display: block;
    font-family: ${cssKit.fonts.bold};
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 3.5px;
    text-transform: uppercase;
    text-align: center;
    color: ${cssKit.vars.color_black_rgba(1)};
    margin: 0 20px 7px 20px;

    ${cssKit.media.greaterThan('medium') `
      font-size: 24px;
      line-height: 24px;
      letter-spacing: 5px;
    `};
  `;
};
export const NextStepsHeaderStyled = styled.h2`
  ${nextStepsHeaderMixin()};
`;
export const NextStepsThanksHeaderStyled = styled.span`
  ${nextStepsHeaderMixin()};
`;

export const nextStepsCopyMixin = (props) => {
  return css`
    display: block;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 2px;
    text-align: center;
    padding: 0 6%;
    margin: ${(props) => (props.moreMarginBottom ? '0 0 10px 0' : '0')};

    ${cssKit.media.greaterThan('medium') `
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 2.5px;
      padding: 0 30%;
    `};
  `;
};
export const NextStepsCopyStyled = styled.h3`
  ${nextStepsCopyMixin()};
`;
export const NextStepsThanksCopyStyled = styled.h2`
  ${nextStepsCopyMixin()};
`;

class NextStepsWrapper extends Component {
  static propTypes = {};
  static defaultProps = {};

  render() {
    const { children, noBg, moreMarginBottom } = this.props;
    return (
      <NextStepsWrapperStyled moreMarginBottom={moreMarginBottom}>
        <NextStepsContentStyled noBg={noBg}>{children}</NextStepsContentStyled>
      </NextStepsWrapperStyled>
    );
  }
}

export default NextStepsWrapper;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/NextStepsWrapper/index.js
 **/